export const RECEIVE_EXERCISE = 'RECEIVE_EXERCISE';
export const RECEIVE_USERINFO = 'RECEIVE_USERINFO';
export const RECEIVE_USER_EXERCISE = 'RECEIVE_USER_EXERCISE';
export const RECEIVE_USER_EXER_DURATION = 'RECEIVE_USER_EXER_DURATION';

export const RECEIVE_USER_AUTH = 'RECEIVE_USER_AUTH';

// export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS';
// export const CHECKOUT_FAILURE = 'CHECKOUT_FAILURE';
